
import { DeskData } from '@/datamodel/deskdata'
import { ResponseData } from '@/datamodel/response-data'
import { Device } from '@/store/types'
import { Options, Vue } from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import HeaderView from '@/components/header/index.vue'
import MarqueeText from '@/components/common/marquee-text.vue'
import { Screenfull } from 'screenfull'
import screenfull from 'screenfull'
import { Watch } from 'vue-property-decorator'
import PcSwitchTable from '@/components/desk/switch-table/d-switch-table.vue'
import CustomMoneyView from '@/components/dialogs/custom-money-dialog-view.vue'
import LimitDialogView from '@/components/dialogs/limit-dialog-view.vue'
import SettingView from '@/components/dialogs/setting-dialog-view.vue'
import ChangePasswordView from '@/components/dialogs/change-pass-view.vue'
import BetHistory from '@/components/dialogs/history-view.vue'
import { to24HoursFormat } from '@/utils'
import MultiViewCenterListItem from '@/components/multi-view/center-list-item.vue'
import MultiViewSideListItem from '@/components/multi-view/side-list-item.vue'
import DGoodRoadPanel from '@/components/desk/good-road/d-good-road-panel.vue'
import axios, { CancelTokenSource } from 'axios'
import router, { ROUTES } from '@/router'
import {
    AxiosSource,
    getMultiTableDetail
} from '@/api'
import { store } from '@/store'
import { UserMutation } from '@/store/module/user'
import { MemberLimit, SocketMessage, Table } from 'vue'
import { GoodRoadMutation } from '@/store/module/good-road'
import { EventBuss, SOCKET_MESSAGE } from '@/utils/constants'
import { MultiViewMutations } from '@/store/module/mutli-view'
import { DeskMutation } from '@/store/module/desk'
import RuleView from '@/components/dialogs/rule-view.vue'
import { useI18n } from 'vue-i18n'

@Options({
    components: {
        HeaderView,
        'marquee-text': MarqueeText,
        CustomMoneyView,
        PcSwitchTable,
        LimitDialogView,
        SettingView,
        ChangePasswordView,
        BetHistory,
        MultiViewCenterListItem,
        MultiViewSideListItem,
        DGoodRoadPanel,
        RuleView
    }
})
export default class MultiViewLoby extends Vue {
    iN = useI18n().t
    showLimitDialog = false
    showHistory = false
    showPasswordForm = false
    showSettings = false
    showCustumChip = false
    showSwicthTable = false
    showGoodRoadPanel = false
    activeDragIndex = -1

    showRule = false

    videoIsLoading = true

    isSuper6Mode = false

    nodePlayer!: any

    videoPlayerCollection: Array<any> = new Array<any>()
    videoPlayerSession = 0
    videoRetryCount = 0
    videoRetryTimer: number | boolean = false
    videoPlaying = false
    videoStallTimer: number | boolean = false
    readonly VIDEO_RETRY_LIMIT = 5
    readonly VIDEO_RETRY_DELAY = 1000
    readonly VIDEO_STALL_DELAY = 1500

    currentDeskNo = -1

    tables: Table[] = []
    multipleTables: Table[] = []
    currentDesk: Table | undefined

    dateTimeStr = to24HoursFormat(new Date())
    dateTimeInterval: number | boolean = false

    hasPendingRequest = false

    deskTimer: number | boolean = false
    serviceTimeOut: number | boolean = false
    countDownTimer: number | boolean = false
    currentCount = -1

    isNoticeView = true
    noticeIsPaused = false

    videos: string[] = []
    videoRequestFailure = 0
    videoRequestTimeOut: boolean | number | any = false
    videoAxiosSource?: CancelTokenSource

    failureCounter = 0

    PULL_INTERVAL = 3000

    gType = ''

    emitter!: Vue['emitter']

    @Getter('isFullScreen') isFullScreen!: boolean
    @Getter('chips') chips!: Array<number>
    @Getter('customChipValue') customChipValue!: number
    @Getter('currentChipIndex') chipIndex!: number
    @Getter('device') device!: Device
    @Getter('selectedTables') selectedTables!: Array<number>
    @Getter('userId') userId!: string
    @Getter('token') token!: string
    @Getter('memberId') memberId!: number
    @Getter('lobyNotice') lobyNotice!: string
    @Getter('deskInfoKey') deskInfoKey!: number
    @Getter('betCoin') betCoin!: number
    @Getter('limitId') limitId!: number
    @Getter('deskLimit') deskLimit!: MemberLimit
    @Getter('goodRoadCount') goodRoadCount!: number
    @Getter('hallTables') storedHallTables!: Table[]

    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    @Action('destroySession') destroySession!: () => void

    @Action('setFullScreen') setFullScreen!: (isFull: boolean) => void
    @Action('setCurrentChipIndex') setCurrentChipIndex!: (
        indexPosition: number
    ) => void
    @Action('setBetCoin') setBetCoin!: (userPoint: number) => void

    timerTimeOut: number | boolean = false
    timerStarted = false

    //#region Vue Methods
    beforeMount(): void {
        if (this.device.display === 1) {
            router.push({ name: ROUTES.LOBY })
            return
        }

        this.emitter.on(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.on(EventBuss.BET_SUCCESS, this.handleOnBetSuccess)
        this.emitter.on(EventBuss.PAGE_ON_VISIBLE, this.onPageVisible)
        this.emitter.on(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
    }

    mounted(): void {
        // this.currentDeskNo = this.currentDesk?.deskId || 0
        this.dateTimeInterval = setInterval(() => {
            this.dateTimeStr = to24HoursFormat(new Date())
        }, 1000)

        this.loadData()
    }

    doCountDown(): void {
        this.timerTimeOut = setTimeout(() => {
            this.multipleTables.forEach((item, index) => {
                if (item.expand.daoJiShiBetTime >= 0) {
                    this.multipleTables[index].expand.daoJiShiBetTime -= 1
                } else {
                    this.multipleTables[index].expand.daoJiShiBetTime = -1
                    this.multipleTables[index].status = 2
                }

                if (item.id === this.currentDeskNo) {
                    this.currentCount = this.multipleTables[
                        index
                    ].expand.daoJiShiBetTime
                }
            })

            this.tables.forEach((item, index) => {
                if (item.expand.daoJiShiBetTime >= 0) {
                    this.tables[index].expand.daoJiShiBetTime -= 1
                } else {
                    this.tables[index].expand.daoJiShiBetTime = -1
                    this.tables[index].status = 2
                }
            })

            this.doCountDown()
        }, 1000)
    }

    cancelCountDown(): void {
        if (typeof this.timerTimeOut === 'number') {
            clearTimeout(this.timerTimeOut)
            this.timerTimeOut = false
            this.timerStarted = false
        }
    }

    beforeUnmount(): void {
        this.stopCountDown()
        this.endService()
        this.stopVideo()
        if (typeof this.dateTimeInterval === 'number') {
            clearInterval(this.dateTimeInterval)
            this.dateTimeInterval = false
        }

        this.cancelCountDown()

        this.emitter.off(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
        this.emitter.off(EventBuss.BET_SUCCESS, this.handleOnBetSuccess)
        this.emitter.off(EventBuss.PAGE_ON_VISIBLE, this.onPageVisible)
        this.emitter.off(
            EventBuss.SOCKET_RECONNECTED,
            this.handleReconnectSuccess
        )
    }

    onPageVisible(): void {
        this.reloadMultiViewData()
    }

    handleReconnectSuccess(): void {
        console.log('SOCKET RECONNECTED')
        this.reloadMultiViewData()
    }

    /** Refresh hall snapshot + multi detail + focused video after tab focus / reconnect. */
    reloadMultiViewData(): void {
        this.loadData()

        if (this.selectedTables.length === 0) return

        this.loadSelectedDesk(true)
    }

    handlesSocketMessages(_message: SocketMessage | any) {
        // console.log(_message.type.toUpperCase())
        const { type, gameTable } = _message

        const _type = (type as string).toUpperCase()

        if (_type === SOCKET_MESSAGE.NEW_GAME) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }

                _copy.expand.shoeNo = sDesk.expand.shoeNo
                _copy.expand.juNo = sDesk.expand.juNo
                _copy.expand.gameNo = sDesk.expand.gameNo
                _copy.expand.daoJiShiBetTime = sDesk.expand.daoJiShiBetTime

                _copy.expand.betFormList = []
                _copy.expand.xianAmount = 0
                _copy.expand.xianDuiAmount = 0
                _copy.expand.zhuangAmount = 0
                _copy.expand.zhuangDuiAmount = 0
                _copy.expand.heAmount = 0

                _copy.expand.playerOne = undefined
                _copy.expand.playerTwo = undefined
                _copy.expand.playerThree = undefined
                _copy.expand.bankerOne = undefined
                _copy.expand.bankerTwo = undefined
                _copy.expand.bankerThree = undefined
                _copy.expand.playerCount = undefined
                _copy.expand.bankerCount = undefined
                _copy.expand.whoWin = -1
                _copy.timeStamp = new Date().getTime()

                this.tables[index] = _copy
            }

            // update multiList data
            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }

                _copy.expand.shoeNo = sDesk.expand.shoeNo
                _copy.expand.juNo = sDesk.expand.juNo
                _copy.expand.gameNo = sDesk.expand.gameNo
                _copy.expand.daoJiShiBetTime = sDesk.expand.daoJiShiBetTime

                _copy.expand.betFormList = []
                _copy.expand.xianAmount = 0
                _copy.expand.xianDuiAmount = 0
                _copy.expand.zhuangAmount = 0
                _copy.expand.zhuangDuiAmount = 0
                _copy.expand.heAmount = 0

                _copy.expand.playerOne = undefined
                _copy.expand.playerTwo = undefined
                _copy.expand.playerThree = undefined
                _copy.expand.bankerOne = undefined
                _copy.expand.bankerTwo = undefined
                _copy.expand.bankerThree = undefined
                _copy.expand.playerCount = undefined
                _copy.expand.bankerCount = undefined
                _copy.expand.whoWin = -1
                _copy.timeStamp = new Date().getTime()

                this.multipleTables[index] = _copy

                if (sDesk.id === this.currentDeskNo) {
                    this.currentDesk = _copy
                    this.currentCount = sDesk.expand.daoJiShiBetTime ?? -1
                }
            }
        } else if (_type === SOCKET_MESSAGE.END_GAME) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }

                _copy.expand.playerOne = sDesk.expand.playerOne
                _copy.expand.playerTwo = sDesk.expand.playerTwo
                _copy.expand.playerThree = sDesk.expand.playerThree
                _copy.expand.bankerOne = sDesk.expand.bankerOne
                _copy.expand.bankerTwo = sDesk.expand.bankerTwo
                _copy.expand.bankerThree = sDesk.expand.bankerThree
                _copy.expand.playerCount = sDesk.expand.playerCount
                _copy.expand.bankerCount = sDesk.expand.bankerCount
                _copy.expand.whoWin = sDesk.expand.whoWin
                _copy.expand.resultList = sDesk.expand.resultList

                // reset bet data
                _copy.expand.betFormList = []
                _copy.expand.xianAmount = 0
                _copy.expand.xianDuiAmount = 0
                _copy.expand.zhuangAmount = 0
                _copy.expand.zhuangDuiAmount = 0
                _copy.expand.heAmount = 0
                this.tables[index] = _copy
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }

                _copy.expand.playerOne = sDesk.expand.playerOne
                _copy.expand.playerTwo = sDesk.expand.playerTwo
                _copy.expand.playerThree = sDesk.expand.playerThree
                _copy.expand.bankerOne = sDesk.expand.bankerOne
                _copy.expand.bankerTwo = sDesk.expand.bankerTwo
                _copy.expand.bankerThree = sDesk.expand.bankerThree
                _copy.expand.playerCount = sDesk.expand.playerCount
                _copy.expand.bankerCount = sDesk.expand.bankerCount
                _copy.expand.whoWin = sDesk.expand.whoWin
                _copy.expand.resultList = sDesk.expand.resultList

                // reset bet data
                _copy.expand.betFormList = []
                _copy.expand.xianAmount = 0
                _copy.expand.xianDuiAmount = 0
                _copy.expand.zhuangAmount = 0
                _copy.expand.zhuangDuiAmount = 0
                _copy.expand.heAmount = 0
                this.multipleTables[index] = _copy
            }
        } else if (_type === SOCKET_MESSAGE.BET) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                if (sDesk.expand.memberId === this.memberId) {
                    _copy.expand.betFormList = sDesk.expand.betFormList
                    _copy.expand.amount = sDesk.expand.amount
                    this.tables[index] = _copy
                    store.commit(UserMutation.SET_BET_COIN, sDesk.expand.amount)
                }
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }
                if (sDesk.expand.memberId === this.memberId) {
                    _copy.expand.betFormList = sDesk.expand.betFormList
                    _copy.expand.amount = sDesk.expand.amount
                    this.multipleTables[index] = _copy
                    store.commit(UserMutation.SET_BET_COIN, sDesk.expand.amount)
                }
            }
        } else if (_type === SOCKET_MESSAGE.STOP_GAME) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                _copy.expand.daoJiShiBetTime = 0
                _copy.status = 2
                this.tables[index] = _copy
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }
                _copy.expand.daoJiShiBetTime = 0
                _copy.status = 2
                this.multipleTables[index] = _copy
            }
        } else if (_type === SOCKET_MESSAGE.CANCEL_GAME) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                _copy.expand.betFormList = []
                _copy.status = sDesk.status
                this.tables[index] = _copy
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }
                _copy.expand.betFormList = []
                _copy.status = sDesk.status
                this.multipleTables[index] = _copy
            }
        } else if (_type === SOCKET_MESSAGE.STOP_BET) {
            const sDesk = gameTable as Table
            const index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                _copy.expand.stopBet = 1
                this.tables[index] = _copy

                if (sDesk.expand.amount) {
                    store.commit(UserMutation.SET_BET_COIN, sDesk.expand.amount)
                }
            }
        } else if (_type === SOCKET_MESSAGE.NEW_SHOE) {
            const sDesk = gameTable as Table
            let index = this.tables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }
                sDesk.expand.betFormList = []

                const {
                    downLimit,
                    upLimit,
                    limitMax,
                    pairDownLimit,
                    pairUpLimit,
                    tieDownLimit,
                    tieUpLimit,
                    superSixDownLimit,
                    superSixUpLimit
                } = _copy
                sDesk.downLimit = downLimit
                sDesk.upLimit = upLimit
                sDesk.limitMax = limitMax
                sDesk.pairDownLimit = pairDownLimit
                sDesk.pairUpLimit = pairUpLimit
                sDesk.tieDownLimit = tieDownLimit
                sDesk.tieUpLimit = tieUpLimit
                sDesk.superSixDownLimit = superSixDownLimit
                sDesk.superSixUpLimit = superSixUpLimit

                this.tables[index] = sDesk
            }

            index = this.multipleTables.findIndex(item => item.id === sDesk.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }
                sDesk.expand.betFormList = []

                const {
                    downLimit,
                    upLimit,
                    limitMax,
                    pairDownLimit,
                    pairUpLimit,
                    tieDownLimit,
                    tieUpLimit,
                    superSixDownLimit,
                    superSixUpLimit
                } = _copy
                sDesk.downLimit = downLimit
                sDesk.upLimit = upLimit
                sDesk.limitMax = limitMax
                sDesk.pairDownLimit = pairDownLimit
                sDesk.pairUpLimit = pairUpLimit
                sDesk.tieDownLimit = tieDownLimit
                sDesk.tieUpLimit = tieUpLimit
                sDesk.superSixDownLimit = superSixDownLimit
                sDesk.superSixUpLimit = superSixUpLimit

                this.multipleTables[index] = sDesk
            }
        }

        this.syncGoodRoadCountFromSocket(_type, gameTable as Table)
    }

    //#endregion

    handleOnBetSuccess(obj: {
        betFormList: any[]
        id: number
        amount: number
    }): void {
        if (obj.betFormList && obj.betFormList) {
            let index = this.tables.findIndex(item => item.id === obj.id)
            if (index !== -1) {
                const _copy = { ...this.tables[index] }

                _copy.expand.betFormList = obj.betFormList
                _copy.expand.amount = obj.amount
                this.tables[index] = _copy
                store.commit(UserMutation.SET_BET_COIN, obj.amount)
            }
            index = this.multipleTables.findIndex(item => item.id === obj.id)
            if (index !== -1) {
                const _copy = { ...this.multipleTables[index] }

                _copy.expand.betFormList = obj.betFormList
                _copy.expand.amount = obj.amount
                this.multipleTables[index] = _copy
                store.commit(UserMutation.SET_BET_COIN, obj.amount)
            }
        }
    }

    loadData(): void {
        if (!this.storedHallTables?.length) return

        this.applyHallTables(
            this.storedHallTables.map(table => ({ ...table }))
        )
    }

    applyHallTables(tables: Table[]): void {
        this.tables = tables

        const maxSelected = Math.min(6, this.tables.length)
        const tableIds = new Set(this.tables.map(table => table.id))
        const validSelected = this.selectedTables.filter(id =>
            tableIds.has(id)
        )

        let nextSelected = validSelected
        if (nextSelected.length < maxSelected) {
            nextSelected = [...validSelected]
            for (let index = 0; index < this.tables.length; index++) {
                const id = this.tables[index].id
                if (nextSelected.includes(id)) continue
                nextSelected.push(id)
                if (nextSelected.length >= maxSelected) break
            }
        }

        if (
            nextSelected.length !== this.selectedTables.length ||
            nextSelected.some((id, i) => id !== this.selectedTables[i])
        ) {
            store.commit(
                MultiViewMutations.SET_SELECTED_MULTIDESK_TABLES,
                nextSelected
            )
        }

        if (this.currentDeskNo === -1 && nextSelected.length > 0) {
            this.currentDeskNo = nextSelected[0]
        } else if (
            this.currentDeskNo !== -1 &&
            !nextSelected.includes(this.currentDeskNo) &&
            nextSelected.length > 0
        ) {
            this.currentDeskNo = nextSelected[0]
        }

        this.syncFocusTimer()

        if (!this.timerStarted) {
            this.timerStarted = true
            this.doCountDown()
        }
    }

    /**
     * Focused desk video/timer/limits come from getMutliDetail list —
     * no separate getDetail call.
     */
    applyFocusedDesk(reloadVideo = true): void {
        if (this.currentDeskNo === -1) {
            this.currentDesk = undefined
            this.currentCount = -1
            this.stopVideo()
            return
        }

        const focused =
            this.multipleTables.find(item => item.id === this.currentDeskNo) ||
            this.tables.find(item => item.id === this.currentDeskNo)

        if (!focused) return

        this.currentDesk = focused
        this.gType = focused.gameTypeNo
        this.currentCount = focused.expand?.daoJiShiBetTime ?? -1
        this.videos = (focused.cmccLine || '').split('$')

        if (this.deskLimit) {
            const {
                superSixDownLimit,
                superSixUpLimit,
                upLimit,
                downLimit,
                tieDownLimit,
                tieUpLimit,
                pairDownLimit,
                pairUpLimit,
                bigTigerUpLimit,
                smallTigerUpLimit,
                bigTigerDownLimit,
                smallTigerDownLimit,
                dragonSevenDownLimit,
                dragonSevenUpLimit,
                bearEightDownLimit,
                bearEightUpLimit
            } = focused

            const _limit: MemberLimit = {
                upLimit,
                downLimit,
                superSixDownLimit,
                superSixUpLimit,
                tieDownLimit,
                tieUpLimit,
                pairDownLimit,
                pairUpLimit,
                id: this.deskLimit.id,
                bigTigerUpLimit,
                smallTigerUpLimit,
                bigTigerDownLimit,
                smallTigerDownLimit,
                dragonSevenDownLimit,
                dragonSevenUpLimit,
                bearEightDownLimit,
                bearEightUpLimit
            }

            store.commit(DeskMutation.SET_DESK_LIMIT, _limit)
        }

        if (reloadVideo && focused.cmccLine) {
            this.videoRetryCount = 0
            this.initVideoPlayer()
        }
    }

    loadSelectedDesk(_forceReload = false): void {
        if (!this.selectedTables.length) return

        let tableIds = this.selectedTables.join(',')
        const _params: any = {
            token: this.token,
            memberId: this.memberId,
            tableIds: tableIds,
            limitId: this.limitId
        }

        if (!_forceReload) {
            this.showLoading()
        }

        getMultiTableDetail(_params)
            .then(r => {
                const response = r.data
                this.failureCounter = 0
                if (!_forceReload) this.hideLoading()
                if (response.status === 200) {
                    this.multipleTables = response.data.gameTableList || []

                    if (response.data.memberChipsShow) {
                        const gameChips = response.data.memberChipsShow
                            .split(',')
                            .map(Number)
                        store.commit(DeskMutation.SET_CHIP_VALUES, gameChips)

                        if (this.chipIndex === -1 && gameChips.length > 0) {
                            this.setCurrentChipIndex(0)
                        }
                    }

                    if (response.data.memberAmount) {
                        store.commit(
                            UserMutation.SET_BET_COIN,
                            response.data.memberAmount
                        )
                    }

                    if (response.data.showTableNo && this.currentDeskNo === -1) {
                        this.currentDeskNo = parseInt(response.data.showTableNo)
                    } else if (
                        this.currentDeskNo === -1 &&
                        this.selectedTables.length > 0
                    ) {
                        this.currentDeskNo = this.selectedTables[0]
                    }

                    this.applyFocusedDesk(this.videoNeedsRestart())

                    if (!this.timerStarted) {
                        this.timerStarted = true
                        this.doCountDown()
                    }
                } else {
                    this.endService()
                    this.emitter.emit(EventBuss.SESSION_EXPIRED)
                }
            })
            .catch(e => {
                if (!axios.isCancel(e)) {
                    this.failureCounter += 1

                    if (!_forceReload) {
                        this.hideLoading()
                    }

                    if (this.failureCounter > 3) {
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            this.iN('prompt.networkerror')
                        )

                        this.emitter.emit(EventBuss.SOCKET_CLOSE)
                        store.commit(UserMutation.DELETE_SESSION)
                        router.push({ name: ROUTES.LOGIN })

                        return
                    }

                    this.serviceTimeOut = setTimeout(() => {
                        this.loadSelectedDesk(true)
                    }, this.PULL_INTERVAL)
                }
            })
    }
    toLoby(): void {
        router.push({ name: ROUTES.LOBY })
    }

    OnShowSwitchTable(): void {
        this.showSwicthTable = !this.showSwicthTable
        if (this.showSwicthTable) this.showGoodRoadPanel = false
    }

    OnShowGoodRoad(): void {
        this.showGoodRoadPanel = !this.showGoodRoadPanel
        if (this.showGoodRoadPanel) this.showSwicthTable = false
    }

    onGoodRoadSync(desksByType: { G002: Table[]; G003: Table[] }): void {
        store.commit(GoodRoadMutation.SET_DESKS_BY_TYPE, desksByType)
    }

    syncGoodRoadCountFromSocket(_type: string, gameTable?: Table): void {
        if (
            _type !== SOCKET_MESSAGE.NEW_GAME &&
            _type !== SOCKET_MESSAGE.END_GAME &&
            _type !== SOCKET_MESSAGE.STOP_GAME &&
            _type !== SOCKET_MESSAGE.NEW_SHOE &&
            _type !== SOCKET_MESSAGE.CANCEL_GAME
        ) {
            return
        }

        if (!gameTable) return

        store.commit(GoodRoadMutation.UPSERT_TABLE, gameTable)
    }

    endService(): void {
        if (AxiosSource) {
            AxiosSource.Source.cancel()
            AxiosSource.Source = axios.CancelToken.source()
        }

        if (typeof this.serviceTimeOut === 'number') {
            clearInterval(this.serviceTimeOut)
            this.serviceTimeOut = false
        }
    }

    startCounDownService(): void {
        if (typeof this.countDownTimer !== 'number') {
            this.currentCount = this.currentDesk?.expand.daoJiShiBetTime ?? 0
            this.countDownTimer = setInterval(() => {
                if (this.currentCount < 0) {
                    this.stopCountDown()
                } else {
                    this.currentCount -= 1
                }
            }, 1000)
        }
    }

    stopCountDown(): void {
        if (typeof this.countDownTimer === 'number') {
            clearInterval(this.countDownTimer)
            this.countDownTimer = false
            this.timerStarted = false
        }
    }

    OnCLickToggleFullScreen(): void {
        this.setFullScreen(!this.isFullScreen)
        if (!this.isFullScreen && screenfull.isEnabled) {
            const sc = screenfull as Screenfull
            sc.exit()
        }
    }

    getChipImageWebp(amount: number): string {
        return require(`@/assets/imgs/chips${amount}.webp`)
    }

    getChipImageWebpPng(amount: number): string {
        return require(`@/assets/imgs/chips${amount}.png`)
    }
    getCustomChipValue(): unknown {
        return this.customChipValue <= 0 ? '自定义' : this.customChipValue
    }

    chipClicked(index: number): void {
        if (index === this.chipIndex && this.chipIndex !== -1) {
            this.setCurrentChipIndex(-1)
            // this.chip = 0
            return
        }

        this.setCurrentChipIndex(index)
        // this.chip = amount
    }

    toggleSuper6Mode(isTrue: boolean): void {
        this.isSuper6Mode = isTrue
    }

    showChipDialog(isTrue: boolean): void {
        if (isTrue) {
            this.showCustumChip = true
        } else {
            if (this.customChipValue > 0) {
                if (this.chipIndex === 5) {
                    // this.chip = 0
                    this.setCurrentChipIndex(-1)
                } else {
                    this.setCurrentChipIndex(5)
                    // this.chip = this.customChipValue
                }
            } else {
                this.showCustumChip = true
            }
        }
    }

    OnClickCustumerService(): void {
        window.open(process.env.VUE_APP_CUSTUMER_SERVICE, '_blank')
    }

    OnClickRules(): void {
        // window.open(
        //     'http://kkw6888.com/resource/rules/rule_home.html',
        //     '_blank'
        // )
        this.showRule = true
    }

    onSwitchTable(desk: Table): void {
        this.showSwicthTable = false
        this.enterGameLoby(desk)
        router.push({ name: ROUTES.GAME })
        this.endService()
        // reset betting
    }

    OnSwitchDeskFocus(deskNo: number): void {
        if (this.currentDeskNo !== deskNo) {
            this.stopVideo()
            this.currentDeskNo = deskNo
            this.applyFocusedDesk(true)
        }
    }

    /** Keep center timer in sync with the focused selected table. */
    syncFocusTimer(): void {
        if (this.currentDeskNo === -1) {
            this.currentCount = -1
            return
        }

        const focused =
            this.multipleTables.find(item => item.id === this.currentDeskNo) ||
            this.tables.find(item => item.id === this.currentDeskNo)

        this.currentCount = focused?.expand?.daoJiShiBetTime ?? -1
    }

    //#region Video Player
    videoNeedsRestart(): boolean {
        return this.videoIsLoading || !this.nodePlayer
    }

    clearVideoRetry(): void {
        if (typeof this.videoRetryTimer === 'number') {
            clearTimeout(this.videoRetryTimer)
            this.videoRetryTimer = false
        }
    }

    clearVideoStall(): void {
        if (typeof this.videoStallTimer === 'number') {
            clearTimeout(this.videoStallTimer)
            this.videoStallTimer = false
        }
    }

    onVideoBuffer(
        session: number,
        evt: 'empty' | 'buffering' | 'full'
    ): void {
        if (session !== this.videoPlayerSession) return

        if (evt === 'full') {
            this.clearVideoStall()
            this.videoPlaying = true
            this.videoIsLoading = false
            return
        }

        if (!this.videoPlaying) {
            this.videoIsLoading = true
            return
        }

        if (typeof this.videoStallTimer === 'number') return
        this.videoStallTimer = window.setTimeout(() => {
            this.videoStallTimer = false
            if (session !== this.videoPlayerSession) return
            this.videoIsLoading = true
        }, this.VIDEO_STALL_DELAY)
    }

    scheduleVideoRetry(session: number): void {
        if (session !== this.videoPlayerSession) return
        if (this.videoRetryCount >= this.VIDEO_RETRY_LIMIT) return
        if (typeof this.videoRetryTimer === 'number') return

        this.videoRetryTimer = window.setTimeout(() => {
            this.videoRetryTimer = false
            if (session !== this.videoPlayerSession) return
            this.initVideoPlayer()
        }, this.VIDEO_RETRY_DELAY)
    }

    // eslint-disable-next-line no-undef
    stopNodePlayer(player?: NodePlayer): void {
        if (!player) return
        try {
            player.stop()
            player.clearView()
        } catch {
            // player may already be stopped
        }
    }

    stopVideo(): void {
        this.videoPlayerSession += 1
        this.clearVideoRetry()
        this.clearVideoStall()
        if (this.videoAxiosSource) {
            this.videoAxiosSource.cancel()
            this.videoAxiosSource = undefined
        }
        this.disposeVideoPlayer()
    }

    async initVideoPlayer(): Promise<void> {
        this.videoIsLoading = true
        this.clearVideoRetry()

        if (this.videoAxiosSource) {
            this.videoAxiosSource.cancel()
        }
        this.videoAxiosSource = axios.CancelToken.source()

        const session = ++this.videoPlayerSession
        this.videoRetryCount += 1
        this.disposeVideoPlayer()

        const retry = (): void => {
            if (session !== this.videoPlayerSession) return
            this.scheduleVideoRetry(session)
        }

        const cmccLine = (this.currentDesk?.cmccLine || '').split('$')[0]
        if (!cmccLine) {
            retry()
            return
        }

        let videoPath = ''
        try {
            const parsed = new URL(cmccLine)
            videoPath = parsed.pathname.replace(/^\//, '')
        } catch {
            retry()
            return
        }
        if (!videoPath) {
            retry()
            return
        }

        const line: number = store.getters['serverLine']
        let apiBase = ''
        if (line === 1) apiBase = process.env.API_LINE1 || ''
        else if (line === 2) apiBase = process.env.API_LINE2 || ''
        else if (line === 3) apiBase = process.env.API_LINE3 || ''
        else if (line === -1) apiBase = store.getters['serverLineStr'] || ''
        else apiBase = process.env.API_LINE1 || ''
        const phpBase = apiBase.replace(/\/$/, '').replace(/\/\/api/, '//xxapi')

        let signedUrls: string[] = []
        try {
            const { data } = await axios.get<{ urls: string[] }>(
                `${phpBase}/videoxx.php`,
                {
                    params: { safeUrl: 'QWE~!@wwCa99AS', path: videoPath },
                    cancelToken: this.videoAxiosSource.token
                }
            )
            signedUrls = Array.isArray(data.urls) ? data.urls : []
        } catch (error) {
            if (axios.isCancel(error)) return
            signedUrls = []
        }

        if (session !== this.videoPlayerSession) return
        if (!signedUrls.length) {
            retry()
            return
        }

        let won = false
        let pending = signedUrls.length

        signedUrls.forEach(url => {
            // eslint-disable-next-line no-undef
            const player = new NodePlayer()
            player.setVolume(0)
            player.setView('videoplayer2')
            player.setBufferTime(1000)
            player.setScaleMode(2)

            let settled = false
            const settleLoser = (): void => {
                if (settled) return
                settled = true
                this.stopNodePlayer(player)
                if (won || session !== this.videoPlayerSession) return
                pending -= 1
                if (pending <= 0) retry()
            }

            player.on('start', () => {
                if (session !== this.videoPlayerSession || won) {
                    settleLoser()
                    return
                }

                settled = true
                won = true
                this.videoRetryCount = 0
                this.nodePlayer = player
                player.clearView()
                player.setView('videoplayer1')
                player.on('videoFrame', () => {
                    if (session !== this.videoPlayerSession) return
                    this.clearVideoStall()
                    this.videoPlaying = true
                    this.videoIsLoading = false
                })
                player.on(
                    'buffer',
                    (evt: 'empty' | 'buffering' | 'full') => {
                        this.onVideoBuffer(session, evt)
                    }
                )
                player.on('error', () => {
                    if (session !== this.videoPlayerSession) return
                    this.videoIsLoading = true
                    this.scheduleVideoRetry(session)
                })
            })

            player.on('error', () => {
                if (won && player === this.nodePlayer) return
                settleLoser()
            })

            this.videoPlayerCollection.push(player)
            player.start(url)
        })
    }

    disposeVideoPlayer(): void {
        this.clearVideoStall()
        this.videoPlaying = false
        const players = this.videoPlayerCollection
        this.videoPlayerCollection = []
        this.nodePlayer = undefined
        players.forEach(player => this.stopNodePlayer(player))
        this.videoIsLoading = true
    }

    //#endregion

    //#region  Drag Events

    handleDragStart(_deskData: Table, e: DragEvent): void {
        const _deskId = _deskData.id
        e.dataTransfer?.setData('id', String(_deskId))
    }

    handleDrop(_deskData: Table, e: DragEvent): void {
        const toId = e.dataTransfer?.getData('id')

        const fromId = this.selectedTables.indexOf(_deskData.id as number)
        if (fromId === -1 || !toId) {
            this.activeDragIndex = -1
            return
        }

        const nextSelected = [...this.selectedTables]
        nextSelected[fromId] = parseInt(toId as string)
        store.commit(
            MultiViewMutations.SET_SELECTED_MULTIDESK_TABLES,
            nextSelected
        )
        this.activeDragIndex = -1
    }

    handleDragLeave(e: DragEvent): void {
        const id = (e.relatedTarget as HTMLElement).id
        if (id === 'box1' || id === 'box2') {
            this.activeDragIndex = -1
        }
    }

    //#endregion

    @Watch('customChipValue', { immediate: false })
    WatchCustumChipChange(value: number): void {
        if (value > 0) this.setCurrentChipIndex(5)
    }

    @Watch('currentDeskNo')
    onCurrentDeskNoChange(deskNo: number): void {
        if (deskNo === -1) {
            this.currentCount = -1
            return
        }
        // Focus switch already calls applyFocusedDesk; this covers programmatic sets
        // before multipleTables is ready (timer only until list arrives).
        this.syncFocusTimer()
    }

    @Watch('currentDesk', { immediate: false, deep: true })
    OnCurrentDeskChange(value: Table): void {
        if (!value) return

        // Multi-view countdown is driven by doCountDown() via multipleTables.
        // Only mirror the focused desk timer here — don't start a second ticker.
        if (value.id === this.currentDeskNo) {
            this.currentCount = value.expand?.daoJiShiBetTime ?? -1
        }
    }

    @Watch('selectedTables', { immediate: true, deep: true })
    onSelectedTablesChange(v: number[]) {
        console.log('onSelectedTablesChange', v)
        if (v.length > 0) {
            const focusChanged =
                this.currentDeskNo === -1 || !v.includes(this.currentDeskNo)
            if (focusChanged) {
                this.stopVideo()
                this.currentDeskNo = v[0]
            }
            this.loadSelectedDesk()
        }
    }

    get timerColor(): string {
        if (this.currentCount > 20) {
            return 'primary'
        } else if (this.currentCount <= 20 && this.currentCount > 10) {
            return 'warning'
        } else {
            return 'danger'
        }
    }

    get leftListData(): Array<Table> {
        const _listData = new Array<Table>()
        this.selectedTables.forEach((deskNo: number, index: number) => {
            if (index > 2) return _listData
            for (let i = 0; i < this.multipleTables.length; i++) {
                if (deskNo === this.multipleTables[i].id)
                    _listData.push(this.multipleTables[i])
            }
        })
        return _listData
    }

    get rightListData(): Array<Table> {
        const _listData = new Array<Table>()

        this.selectedTables.forEach((deskNo: number, index: number) => {
            if (index > 2) {
                for (let i = 0; i < this.multipleTables.length; i++) {
                    if (deskNo === this.multipleTables[i].id)
                        _listData.push(this.multipleTables[i])
                }
            }
        })

        return _listData
    }

    get centerListData(): Array<Table> {
        const _listData = new Array<Table>()
        this.tables.forEach((desk: Table) => {
            let isListed = false
            for (let index = 0; index < this.selectedTables.length; index++) {
                const tableNo = this.selectedTables[index]
                if (tableNo === desk.id) {
                    isListed = true
                    // break
                }
            }
            if (!isListed) _listData.push(desk)
        })

        return _listData
    }

    get chip(): number {
        if (this.chipIndex === 5) return this.customChipValue

        if (this.chipIndex === -1) return 0

        const amt = this.chips[this.chipIndex]
        if (amt) return amt
        return 0
    }

    get title(): string {
        let currentDeskData: Table | undefined = undefined

        for (let i = 0; i < this.tables.length; i++) {
            const desk = this.tables[i]
            if (desk.id === this.currentDeskNo) {
                currentDeskData = desk
                break
            }
        }

        if (!currentDeskData) return ''

        const { gameTypeNo, id, tableNo } = currentDeskData as Table

        if (gameTypeNo === 'G002') {
            return `百家乐 ${tableNo} 号桌`
        } else {
            return `龙虎 ${tableNo} 号桌`
        }
    }
}
